module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articleComponent"
  }, [_c('v-content', {
    attrs: {
      "articleContent": _vm.articleContent,
      "tags": _vm.tags,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fcb5239"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/article/index.vue
// module id = 264
// module chunks = 1